/*
*
* File JS per la Homepage
*
*/


// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import ScrollMagic from 'ScrollMagic';
import anime from "animejs";
// import 'debug.addIndicators';

import slowNumber from 'jsUtilities/slowNumber';

//--------------------------------------------------------------------//


// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroImage from 'imComponents/hero-image/hero-image';
import heroVideo from 'imComponents/hero-video/hero-video';
import modal from 'imComponents/modal/modal';

import featuredBrands from 'components/featured-brands/featured-brands';

//--------------------------------------------------------------------//


// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './homepage.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

modal();

//--------------------------------------------------------------------//


// JS SPECIFICO PAGINA
//--------------------------------------------------------------------//

const heroAnimate = () => {
    // Animation title
    const title = document.querySelector('.im-hero-image__title');
    const ctaImage = document.querySelector('.im-hero-image__cta');
    const ctaVideo = document.querySelector('.im-hero-video__cta');

    if(title) 
    {
        title.innerHTML = title.textContent.replace(/\S/g, "<span class='letter'>$&</span>");
        let letters = title.querySelectorAll('.letter');
        if(letters) {
            anime.timeline({loop: false})
            .add({
                targets: letters,
                opacity: [0,1],
                easing: "easeInOutQuad",
                duration: 500,
                delay: (el, i) => 15 * (i+1),
                begin: function(anim) {
                    title.classList.add('show');
                },
                complete: function(anim) {
                    if (ctaImage){
                        ctaImage.classList.add('show');
                    } 

                    if (ctaVideo){
                        ctaVideo.classList.add('show');
                    } 
                }
            })
        }
    }
}
heroAnimate();

const infographicAnimate = () => {
    let controller = new ScrollMagic.Controller();
    let infographic = document.querySelector('.infographic');

    if (!infographic) return;

    let infoRows = document.querySelectorAll('.infographic__row');

    infoRows.forEach((el, i) => {
        new ScrollMagic.Scene({
            triggerElement: el,
            offset: 0,
            triggerHook: 0.8,
            reverse: false,
        })
        // .addIndicators()
        .on('enter', () => {
            let innerNumbers = el.querySelectorAll('.slowNumberHp');

            innerNumbers.forEach(elNum => {
                setTimeout(
                    slowNumber(elNum),
                    200
                )
            });
        })
        .setClassToggle(el, 'animate')
        .addTo(controller);
    });
}

infographicAnimate();

//--------------------------------------------------------------------//